<div
    [attr.data-uitype]="'container'"
    [attr.data-styletarget]="id + '-container'"
>
    @if (loaded()) { @for(article of articles(); track article.url) {
    <div class="text-dat-grey-900 font-body-2 flex align-center mt-[10px]">
        @if(article.name.length > 50) {
        <span [matTooltip]="article.name">
            {{ shortName(article.name) }}
        </span>
        } @else {
        <span>{{ article.name }}</span>
        }
        <a
            [href]="article.url"
            target="_blank"
            class="ml-2"
            (click)="clickedLink(article.url)"
        >
            <span
                class="material-symbols-outlined h-[20px] w-[20px] leading-[20px] text-dat-grey-900"
            >
                open_in_new
            </span>
        </a>
    </div>
    <div class="font-caption-grey mb-[10px]">
        {{ article.date | date: DATE_FORMAT }}
    </div>
    @if(!$last) {
    <div
        class="border-b-[1px] border-x-0 border-t-0 border-solid border-dat-grey-100"
    ></div>
    } } } @else { @for(row of rowsArray; track $index) {
    <div
        [attr.data-uitype]="'loader'"
        class="animate-pulse bg-dat-grey-100 w-[400px] h-[50px]"
    ></div>
    } }
</div>
